export default function (milliseconds = 1000): Promise<void> {
  if (milliseconds == 0) return Promise.resolve();
  return new Promise((resolve) => setTimeout(() => resolve(), milliseconds));
}
